import React from 'react';
import { Link, useParams } from 'react-router-dom';

function AddAgencyOfficialsBreadCrumb() {
   const {id, plantName} = useParams();
          // Convert slug (with -) back to spaces
          const decodedPlantName = plantName.replace(/-/g, ' ');
  return (
    <div className="breadcrumb-wrapper py-3 px-3">
      <div className="container">
        <h2 className="breadcrumb-title">{decodedPlantName}</h2>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb custom-breadcrumb mb-0">
            <li className="breadcrumb-item">
                          <Link
                            to={`/renewableagencydashboard/${(plantName).replace(/\s+/g, "-")}/${id}`}
                            className="breadcrumb-link"
                          >
                            Renewable Agency Dashboard
                          </Link>
                        </li>
            
                        <li className="breadcrumb-item">
                          <Link
                            to={`/renewableagency-officials/${(plantName).replace(/\s+/g, "-")}/${id}`}
                            className="breadcrumb-link"
                          >
                            Renewable Agency Officials
                          </Link>
                        </li>
            <li className="breadcrumb-item active" aria-current="page">
                Add Renewable Agency Officials
            </li>
          </ol>
        </nav>
      </div>
    </div>
  );
}

export default AddAgencyOfficialsBreadCrumb;
